"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDeleteCtrl = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const index_1 = require("../../i18n/index");
const index_2 = require("../../services/index");
const render_service_1 = require("../../services/render.service");
const page_state_1 = require("../../state/page.state");
/** Protect users from deleting all of their data */
const MAX_TAG_COUNT = 5;
exports.CollectionDeleteCtrl = {
    get selectedCount() {
        return page_state_1.CurrentState.Tag.collections.length;
    },
    canDisplay() {
        return index_2.Services.Token.has(core_api_1.IkeToken.COLLECTION_DELETE);
    },
    canDelete() {
        if (!exports.CollectionDeleteCtrl.canDisplay()) {
            return false;
        }
        const selectedTagIds = page_state_1.CurrentState.Tag.tags;
        return selectedTagIds.length > 0 && selectedTagIds.length <= MAX_TAG_COUNT;
    },
    showConfirmModal() {
        if (!exports.CollectionDeleteCtrl.canDelete()) {
            exports.CollectionDeleteCtrl.rejectCollectionDelete();
            return;
        }
        const confirmModal = new CollectionDeleteConfirmModal({
            title: index_1.T.COLLECTION_DELETE_TITLE,
            confirm: index_1.T.COLLECTION_DELETE,
            success: {
                key: index_1.T.COLLECTION_DELETE_SUCCESS,
                attrs: {
                    count: exports.CollectionDeleteCtrl.selectedCount,
                },
            },
        });
        confirmModal.open();
    },
    deleteCollections() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!exports.CollectionDeleteCtrl.canDelete()) {
                throw Error('Cannot delete collections');
            }
            const collectionSummaries = page_state_1.CurrentState.Tag.collections;
            yield index_2.Services.Collection.remove(collectionSummaries);
        });
    },
    rejectCollectionDelete() {
        notification_service_1.NotificationService.warn({
            key: index_1.T.COLLECTION_DELETE_REJECT,
            attrs: {
                max: MAX_TAG_COUNT,
            },
        });
    },
};
class CollectionDeleteConfirmModal extends modal_form_component_1.ModalFormComponent {
    get nodes() {
        return (0, render_service_1.m)('p', (0, index_1.Translate)(index_1.T.COLLECTION_DELETE_CONFIRM, exports.CollectionDeleteCtrl.selectedCount));
    }
    submit() {
        return exports.CollectionDeleteCtrl.deleteCollections();
    }
}
//# sourceMappingURL=collection.delete.ctrl.js.map